/**
 * 工伤单位
 */

export const InjuryUnitList=[
    {
        prop:"code",
        label:"代码",
        width:"150",
        isShow:false
    },
    {
        prop:"name",
        label:"单位名称",
        width:"150",
        isShow:true
    },
    {
        prop:"phone",
        label:"联系电话",
        width:"150",
        isShow:true
    }    ,
    // {
    //     prop:"RegisteredCapital",
    //     label:"注册资本(万元)",
    //     width:"150",
    //     isShow:false
    // },
    {
        prop:"creditCode",
        label:"统一社会信用代码",
        width:"150",
        isShow:true
    },
    {
        prop:"email",
        label:"邮箱",
        width:"150",
        isShow:true
    },
    {
        prop:"website",
        label:"网址",
        width:"150",
        isShow:true
    },
    {
        prop:"briefContent",
        label:"简介",
        width:"150",
        isShow:true
    },
    {
        prop:"address",
        label:"地址",
        width:"150",
        isShow:true
    },
    {
        prop:"legalPerson",
        label:"法人",
        width:"150",
        isShow:true
    },
    {
        prop:"legalPersonPhone",
        label:"法人电话",
        width:"150",
        isShow:true
    },


 ]

